import React, { Component, createRef, Dispatch } from 'react';
import { ILoginFormState, ILoginFormProps } from '../../models/pages/login';
import { IAppState, IAction } from '../../models/action/core';
import * as Actions from '../../store/actions/login';
import { connect } from 'react-redux';
import { Log, Level, Logger } from 'ng2-logger';
import Translator from '../../core/i18n';
import { coreActions } from '../../store/constants/all';
import { newNotification } from '../../store/actions/core';
import { Redirect } from 'react-router-dom';
import { UserType } from '../../models/enums/userType';
import ReCAPTCHA from 'react-google-recaptcha';
import { SetLoginFormData, verificateUser } from '../../store/actions/login';
import { Common } from '../../core/common';

const T = Translator.create();

const _logger = Log.create('login-form.tsx');
const _common = new Common();

class LoginForm extends React.Component<ILoginFormProps> {
    private txtUserName = createRef<HTMLInputElement>();
    private txtPasswordRef = createRef<HTMLInputElement>();

    constructor(props: ILoginFormProps) {
        super(props);
    }

    state = {
        googleCaptchaToken: ""
    }


    public componentDidMount() {
        const focusItem = this.txtUserName.current!;
        focusItem.focus();
    }

    public usernameKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            const focusItem = this.txtPasswordRef.current!;
            focusItem.focus();
        }
    }

    public textboxKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            this.onSubmit();
        }
    }


    onCaptchaChange = (token: string) => {
        this.setState({ googleCaptchaToken: token });
    };

    // public submitHandler = () => {
    //     const focusItem = this.txtUserName.current!;

    //     // remove white space
    //     const username = focusItem.value ? focusItem.value.replace(/(^\s+)|(\s+$)/gi, '') : '';
    //     if (username.length > 0) {
    //         this.props.dispatch(Actions.setCurrentPage('LoginAfter', username));
    //     } else {
    //         focusItem.value = '';
    //         focusItem.focus();
    //         this.props.dispatch(newNotification(T.t('r_enter_your_username'), '', '', 'topRight', 'warning'));
    //     }
    // };

    public onResetClick = () => {
        if (this.props.forgotPasswordUrlRecover?.toLowerCase() === 'true' && this.props.forgotPasswordURLLink?.length > 0) {
            window.location.href = this.props.forgotPasswordURLLink;
        } else {
            this.props.dispatch(Actions.setCurrentPage('ResetPassword', ''));
        }
    }

    public onSubmit = () => {
        const passwordItem = this.txtPasswordRef.current!;
        const focusItem = this.txtUserName.current!;

        // remove white space
        let username = focusItem.value ? focusItem.value.replace(/(^\s+)|(\s+$)/gi, '') : '';

        // remove white space
        const password = passwordItem.value ? passwordItem.value.replace(/(^\s+)|(\s+$)/gi, '') : '';

        if (password.length > 0) {
            if(this.props.googleCaptchaSiteKey && this.props.googleCaptchaSiteKey.length > 0 && this.state.googleCaptchaToken === ""){
                this.props.dispatch(newNotification(T.t('r_google_captcha_invalid_input_error'), '', '', 'topRight', 'warning'));

            }else{
                if(this.props.isThereTwoFactorAuth){
                    let loginFormData = {
                        username: username,
                        password: password,
                        loginCulture: this.props.loginCulture,
                        googleCaptchaToken: this.state.googleCaptchaToken,
                        isExternal: false
                    }
                    this.props.dispatch(SetLoginFormData(loginFormData, 'setLoginFormData', 'get'))
                    this.props.dispatch(verificateUser(username, "", "verificateUser", "get", () => 
                        this.props.dispatch(Actions.clickLoginForm(username, password, this.props.loginCulture, this.state.googleCaptchaToken, 'LoginFormSubmitLoading', 'get'))))
                    
                }else
                {
                    this.props.dispatch(Actions.clickLoginForm(username, password, this.props.loginCulture, this.state.googleCaptchaToken, 'LoginFormSubmitLoading', 'get'));
                }

            }
        } else {
            passwordItem.value = '';
            passwordItem.focus();
            this.props.dispatch(newNotification(T.t('r_enter_your_password'), '', '', 'topRight', 'warning'));
        }
    }

    public render() {
        const loginText = this.props.headerText;
        let redirectRoot;
        if (this.props.isLogin) {
            let isLoading = _common.GetLoginLoading();
            redirectRoot = isLoading ? null :  <Redirect to={this.props.userType !== UserType.Admin ? window.appSettings.DEFAULT_URL + '/u/Home/Index' : window.appSettings.DEFAULT_URL + '/u/Home/Cockpit'} />;
        }


        return (
            <form autoComplete='off' className="col-12 d-flex flex-column">

                {redirectRoot}
                <div className="alms-login-form">
                    <div className="mb-3">
                        <div className="form-input form-group a">
                            <input ref={this.txtUserName}
                                   onKeyPress={this.usernameKeyPress}
                                   type="text" id="txtUserName"
                                   name="txtUserName"
                                   required={true}
                                   autoComplete='new-password' />
                            <span className="highlight" />
                            <span className="bar" />
                            <label htmlFor="txtUserName">{T.t('r_my_forgot_password_input_placeholder')}</label>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="form-input form-group">
                            <input id="txtPasswordRef"
                                ref={this.txtPasswordRef}
                                onKeyPress={this.textboxKeyPress}
                                type="password" required={true}
                                name="txtPasswordRef" autoComplete="new-password" />
                            <span className="highlight" />
                            <span className="bar" />
                            <label htmlFor="txtPasswordRef">{T.t('r_password')}</label>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between mb-3 align-items-center">

                        <div className='w-50' style={{ textAlign: "start" }}>
                            {(typeof(this.props.forgotMyPassword) === 'string' && this.props.forgotMyPassword?.toLowerCase() === 'true' && typeof(this.props.forgotPasswordEnable) === 'string' &&  this.props.forgotPasswordEnable?.toLowerCase() === 'true') ?
                                (
                                    <a id="resetButton" onClick={this.onResetClick} className="forgot"  >{T.t('r_my_forgot_password')}</a>
                                ) :
                                ('')
                            }
                        </div>
                        <button type="button" id="submitButton" onClick={this.onSubmit} className="btn btn-green w-50">{T.t('r_gen_login')}</button>

                    </div>
                    {this.props.googleCaptchaSiteKey && this.props.googleCaptchaSiteKey.length > 0 &&
                        <ReCAPTCHA
                            style={{display:'flex', justifyContent: 'center'}}
                            sitekey={this.props.googleCaptchaSiteKey}
                            onChange={(token: any) => this.onCaptchaChange(token)}
                        />
                    }
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ILoginFormProps): ILoginFormProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: ILoginFormProps = Object.assign({}, ownProps, {
        username: state.login.identitiy.userName,
        headerText: state.login.login.headerText,
        forgotMyPassword: state.login.login.forgotMyPassword,
        forgotPasswordURLLink: state.login.login.forgotPasswordURLLink,
        forgotPasswordEnable: state.login.login.forgotPasswordEnable,
        forgotPasswordUrlRecover: state.login.login.forgotPasswordUrlRecover,
        requiresQuestionAndAnswer: state.login.login.requiresQuestionAndAnswer,
        isLogin: state.login.identitiy.isLogin,
        loginCulture: state.login.loginCulture,
        userType: state.login.identitiy.userType,
        isAlmsPlusLogin: state.login.login.isAlmsPlusLoginPage,
        googleCaptchaSiteKey: state.login.login.googleCaptchaSiteKey,
        isThereTwoFactorAuth: state.login.login.isThereTwoFactorAuth
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const CLoginForm = connect(
    mapStateToProps,
    dispatchProps
)(LoginForm);

export default CLoginForm;
